import { BaseIcon, BaseIconProps } from './BaseIcon';

export const SparklesGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="sparklesGrad" {...props}>
    <path 
      d="M12 3v18m9-9H3m15.364-6.364L5.636 18.364m12.728 0L5.636 5.636" 
      stroke="url(#sparklesGrad)" 
    />
  </BaseIcon>
);
